<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_ii"></a><a id="page_iii">The Pashtun Tribes in</a></h1><a id="page_iii">
<h1 class="title1">AFGHANISTAN</h1>
<p class="author">BEN ACHESON</p>
<div class="image_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?8f62c14c